import { Theme } from "@mui/material";

export const styles = (theme: Theme) => ({
  "&": {
    fontFamily: theme.typography.fontFamily,
    boxShadow: `2px 2px 16px -2px ${theme.palette.grey[300]}`,
    borderRadius: "30px",
    padding: "15px 20px",
    border: `2px solid ${theme.palette.common.white}`,
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    justifyContent: "space-between",
  },
  "&:focus": {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
  },
  "&:hover": {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
  },
  "&.MuiListItemButton-gutters": {
    margin: "20px 0",
  },
  "&.Mui-selected": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-selected:hover": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-selected:focus": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
  },
});
